import { styled } from '@material-ui/core';

export const Media = styled('div')({
  display: 'flex',

  '& > *': {
    maxWidth: '100%',
  },
});
